// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__e1SyL","dragIcon":"SortableItem_dragIcon__2h--o","disabled":"SortableItem_disabled__3FIYK"};